import { Component, FC, useEffect } from 'react';
import { HeaderWrapper } from '../../../_metronic/layout/components/header';
import { createRoot } from 'react-dom/client';
import './Kutupyildizi.css'
import "react-multi-carousel/lib/styles.css";
import ReactPlayer from 'react-player';

const sliderContents = [
  {
    index: 1,
    url: "https://akademi-admin.vestel.com.tr/videos/kutupyildizi.mp4",
    title: "Kutup Yıldızı Tanıtım Videosu",
    text: "Kutup Yıldızı ile deneyimli çalışanlar, yeni yolculuklara rehber olur."
  }
];

class KutupyildiziWrapper extends Component {
  componentDidMount() {
    createRoot(document.getElementById('masterHeader')!).render(<HeaderWrapper title='Kutup Yıldızı' isBackIconVisible={false} />);
    createRoot(document.getElementById('subHeader')!).unmount();
    createRoot(document.getElementById('pageHeader')!).unmount();
  }

  render() {
    return (
      <>

      </>
    );
  }
}

const KutupyildiziWrapperPage: FC = () => {

  useEffect(() => {
    document.getElementById('kt_app_content_container')!.style.backgroundColor = "#FFF";
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const video = sliderContents[0];
  return (
    <>
      <KutupyildiziWrapper></KutupyildiziWrapper>

       <div 
        className="video-page-container" 
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
          backgroundColor: "#F8F9FF",
          padding: "20px"
        }}
      >
        <h1 className="videos-title mb-4">{video.title}</h1>

        <ReactPlayer
          url={video.url}
          controls
          pip
          width="80%"
          height="auto"
          style={{ maxWidth: "1200px", borderRadius: "12px", overflow: "hidden", boxShadow: "0 6px 20px rgba(0,0,0,0.15)" }}
        />

        <p className="video-description mt-4" style={{ maxWidth: "900px", textAlign: "center", fontSize: "1.1rem", color: "#333" }}>
          {video.text}
        </p>
      </div>
    </>
  )
}
export default KutupyildiziWrapperPage;